export { default as PostActions } from './component';
